export const DEFAULT_PROXIMITY_MILES = 10;

export function haversineMiles(a, b) {
  if (![a?.latitude, a?.longitude, b?.latitude, b?.longitude].every(Number.isFinite)) return null;
  const toRad = (deg) => (deg * Math.PI) / 180;
  const dLat = toRad(b.latitude - a.latitude);
  const dLon = toRad(b.longitude - a.longitude);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(a.latitude)) * Math.cos(toRad(b.latitude)) * Math.sin(dLon / 2) ** 2;
  return 2 * 3958.8 * Math.asin(Math.sqrt(h));
}

const HIGH_TIERS = new Set(['high', 'veryHigh']);

function nearestLowRisk(row, candidates, radiusMiles) {
  let best = null;
  candidates.forEach((candidate) => {
    if (candidate.tier?.id !== 'low' || candidate.school.id === row.school.id) return;
    const miles = haversineMiles(row.school, candidate.school);
    if (miles === null || miles > radiusMiles) return;
    if (!best || miles < best.miles) best = { row: candidate, miles };
  });
  return best;
}

/**
 * Proximity opportunities: every High / Very High risk charter paired with the
 * nearest Low-risk charter and the nearest Low-risk district school within
 * `radiusMiles` (scored rows from scoreRiskSchools).
 */
export function proximityPairs(charterRows, peerRows, radiusMiles = DEFAULT_PROXIMITY_MILES) {
  return (charterRows || [])
    .filter((row) => HIGH_TIERS.has(row.tier?.id))
    .map((row) => ({
      row,
      nearestCharter: nearestLowRisk(row, charterRows, radiusMiles),
      nearestDistrict: nearestLowRisk(row, peerRows || [], radiusMiles),
    }));
}
